import styled from '@emotion/styled';

export const InputContainer = styled.div<{ error?: string; isTouched?: boolean }>`
    background-color: ${({ theme }) => theme.base.color.grey100};
    border: 1px solid
        ${({ error, isTouched, theme }) => {
            if (error) {
                return theme.base.color.bloodyMary;
            }
            if (isTouched) {
                return theme.base.color.emerald;
            }
            return theme.base.color.grey300;
        }};
    width: 100%;
    box-sizing: border-box;
    border-radius: ${({ theme }) => theme.base.radius.default};
    padding: 10px 16px;
    font-size: ${({ theme }): string => theme.base.font.size.small};
    color: ${({ theme }) => theme.base.color.black200};
    display: flex;
    align-items: center;
    font-weight: 600;
    min-height: 40px;

    input:-webkit-autofill,
    input:-webkit-autofill:hover,
    input:-webkit-autofill:focus,
    textarea:-webkit-autofill,
    textarea:-webkit-autofill:hover,
    textarea:-webkit-autofill:focus,
    select:-webkit-autofill,
    select:-webkit-autofill:hover,
    select:-webkit-autofill:focus {
        -webkit-text-fill-color: $dark-black;
        -webkit-box-shadow: 0 0 0px 1000px $main-white inset;
        transition: background-color 5000s ease-in-out 0s;
    }

    &:focus-within {
        border: 1px solid
            ${({ error, isTouched, theme }) => {
                if (error) {
                    return theme.base.color.bloodyMary;
                }
                if (isTouched) {
                    return theme.base.color.emerald;
                }
                return theme.base.color.black300;
            }};
    }
`;

export const UnstyledInput = styled.input`
    border: none;
    width: 100%;
    background-image: none;
    background-color: transparent;
    box-shadow: none;
    margin: 0;
    color: ${({ theme }) => theme.base.color.black200};
    height: 18px;
    line-height: 18px;
    font-weight: ${({ theme }) => theme.base.font.weight.regular};
    font-size: ${({ theme }) => theme.base.font.size.normal};
    font-size: ${({ theme }) => theme.base.font.family.text};

    &:focus {
        outline: none;
    }

    &::placeholder {
        color: ${({ theme }) => theme.base.color.black300};
        font-size: ${({ theme }) => theme.base.font.size.small};
    }
`;

export const UnstyledInputDiv = styled.div`
    border: none;
    width: 100%;
    background-image: none;
    background-color: transparent;
    box-shadow: none;
    margin: 0;
    color: ${({ theme }) => theme.base.color.black200};
    height: 18px;
    line-height: 18px;
    font-weight: ${({ theme }) => theme.base.font.weight.regular};
    font-size: ${({ theme }) => theme.base.font.size.normal};
    font-size: ${({ theme }) => theme.base.font.family.text};

    &:focus {
        outline: none;
    }

    &::placeholder {
        color: ${({ theme }) => theme.base.color.black300};
        font-size: ${({ theme }) => theme.base.font.size.small};
    }
`;
